import getData from '../../dataFetcher/getDataFetcher';
import putData from '../../dataFetcher/putDataFetcher';

const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const fetchEventCodes = async (eventStatus, token) => {
  try {
    let apiUrl = `${baseUrl}event-code/lists`;
    apiUrl += eventStatus && eventStatus.trim() !== '' ? `?event_status=${eventStatus}` : '';
    const response = await getData(apiUrl, null, token);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateEventCodes = async (payload, token) => {
  try {
    const apiUrl = `${baseUrl}event-code/update`;
    const response = await putData(apiUrl, payload, token);
    return response;
  } catch (error) {
    throw error;
  }
};